import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39d98498"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MyOfferPriceList" }
const _hoisted_2 = { class: "tab" }
const _hoisted_3 = { class: "list-item" }
const _hoisted_4 = { class: "list-info" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = { class: "address" }
const _hoisted_9 = { class: "add" }
const _hoisted_10 = { class: "price" }
const _hoisted_11 = {
  key: 0,
  class: "text"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("我报的 ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { style: {"color":"#FFF","background":"#ff6633","border-radius":"6px","padding":"3px 5px"} }, "地苗价", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("：")
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "text"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("我报的 ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { style: {"color":"#FFF","background":"#ff6633","border-radius":"6px","padding":"3px 5px"} }, "上车价", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode("：")
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 2,
  class: "text"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("我报的")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { style: {"color":"#FFF","background":"#ff6633","border-radius":"6px","padding":"3px 5px"} }, "到货价", -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode("：")
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "num" }
const _hoisted_27 = { class: "list-received" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "avatar" }
const _hoisted_30 = { class: "titleright" }
const _hoisted_31 = { class: "top" }
const _hoisted_32 = {
  key: 0,
  class: "bottom"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode("实名认证")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("企业认证")
const _hoisted_35 = { class: "price" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "他的报价：", -1))
const _hoisted_37 = { class: "num" }
const _hoisted_38 = { class: "area" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发货地区：", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other" }, [
  /*#__PURE__*/_createElementVNode("span", null, "其它说明")
], -1))
const _hoisted_41 = { class: "phone" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("拨打电话")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_44 = { class: "telNum" }
const _hoisted_45 = { class: "btn" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("暂不拨打")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("立即呼叫")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanTab = _resolveComponent("VanTab")!
  const _component_VanTabs = _resolveComponent("VanTabs")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VipTag = _resolveComponent("VipTag")!
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_vanButton = _resolveComponent("vanButton")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_VanTabs, {
        type: "card",
        active: $setup.active,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.active) = $event)),
        onClick: $setup.onTabClick,
        color: "#32ae57",
        sticky: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabs, (item) => {
            return (_openBlock(), _createBlock(_component_VanTab, {
              title: item.title,
              name: item.name
            }, null, 8, ["title", "name"]))
          }), 256))
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    ($setup.active==0)
      ? (_openBlock(), _createBlock(_component_VanList, {
          key: 0,
          class: "list",
          loading: $setup.loading,
          "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => (($setup.loading) = $event)),
          onLoad: $setup.getList,
          finished: $setup.finished,
          "immediate-check": false,
          "finished-text": "没有更多了"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (item.photos.length)
                  ? (_openBlock(), _createBlock(_component_VanImage, {
                      key: 0,
                      src: item.photos[0],
                      alt: "图片",
                      width: "96",
                      height: "96",
                      fit: "cover",
                      radius: "4"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.profile), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, "地址:" + _toDisplayString(item.receiptAddress), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (item.payTerm ==0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
                      : _createCommentVNode("", true),
                    (item.payTerm ==1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_20))
                      : _createCommentVNode("", true),
                    (item.payTerm ==2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_25))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(item.price) + "元/" + _toDisplayString(item.unit), 1)
                  ])
                ])
              ]))
            }), 256))
          ]),
          _: 1
        }, 8, ["loading", "finished"]))
      : _createCommentVNode("", true),
    ($setup.active==1)
      ? (_openBlock(), _createBlock(_component_VanList, {
          key: 1,
          class: "list",
          loading: $setup.rloading,
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => (($setup.rloading) = $event)),
          onLoad: $setup.getreceivedList,
          finished: $setup.rfinished,
          "immediate-check": false,
          "finished-text": "没有更多了"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rlist, (item) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_VanImage, {
                      src: item.avatarUrl,
                      round: "",
                      width: "50",
                      height: "50"
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("span", null, _toDisplayString(item.nickName), 1)
                    ]),
                    (item.viprank>1 || item.hasIdCard || item.hasBusinessLicense)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createVNode(_component_VipTag, {
                            type: item.vipRank,
                            year: item.year
                          }, null, 8, ["type", "year"]),
                          _withDirectives(_createVNode(_component_VanTag, {
                            type: "primary",
                            plain: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_33
                            ]),
                            _: 2
                          }, 1536), [
                            [_vShow, item.hasIdCard]
                          ]),
                          _withDirectives(_createVNode(_component_VanTag, {
                            type: "success",
                            plain: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_34
                            ]),
                            _: 2
                          }, 1536), [
                            [_vShow, item.hasBusinessLicense]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("span", _hoisted_37, _toDisplayString(item.price) + "/" + _toDisplayString(item.unit), 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("span", null, _toDisplayString(item.address), 1)
                ]),
                _hoisted_40,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.photos, (img) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "photos",
                    key: img.key
                  }, [
                    _createVNode(_component_VanImage, {
                      src: img,
                      radius: "4",
                      width: "144",
                      height: "144"
                    }, null, 8, ["src"])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_VanButton, {
                    type: "success",
                    size: "mini",
                    color: "#F83B2D",
                    round: "",
                    onClick: ($event: any) => ($setup.getTel(item.userId))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_42
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            }), 256))
          ]),
          _: 1
        }, 8, ["loading", "finished"]))
      : _createCommentVNode("", true),
    _createVNode(_component_VanPopup, {
      class: "callDialog",
      show: $setup.isShowTel,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (($setup.isShowTel) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          _createTextVNode("是否拨打 " + _toDisplayString($setup.tel), 1),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_vanButton, {
              round: "",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.cancel())),
              icon: "close",
              size: "mini"
            }, {
              default: _withCtx(() => [
                _hoisted_46
              ]),
              _: 1
            }),
            _createVNode(_component_vanButton, {
              round: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.call())),
              icon: "phone",
              color: "#33AC9C",
              size: "mini"
            }, {
              default: _withCtx(() => [
                _hoisted_47
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}